import { RecordBuilder } from "slotworks/server/builders/record-builder";
import { User, FreespinUpdate } from "slotworks/integration/revolver/schema/spin-record-schema";
import Persisted_Progress from "./schema/persisted-progress";
import { NextGameState } from "./spin-record-builder";
import { RespinState } from "./recovery-record-builder";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import { Eval } from "slotworks/integration/revolver/schema/pick-record-schema";
import BonusRecord from "./schema/bonus-record";

class RainbowStacksBonusRecordBuilder implements RecordBuilder {

    public filter(data: any): boolean {
        let bonusResponse: BonusResponseSchema;

        if (data && data.data) {
            bonusResponse = data.data as BonusResponseSchema;
        }

        return bonusResponse && bonusResponse.RESULTS !== undefined && bonusResponse.RESULTS.game == "BONUS";
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let bonusResponse: BonusResponseSchema;

        if (data && data.data) {
            bonusResponse = data.data as BonusResponseSchema;
            // WrapperMediator.roundStarted(bonusResponse.RESULTS.round_id);
            // WrapperMediator.bonusResponseReceived(bonusResponse);
        }

        const record = new BonusRecord();
        record.retriggers = bonusResponse.RESULTS.state.retriggers;
        record.jackpotSymbol = bonusResponse.RESULTS.state.jackpotSymbol;
        record.creditsWon = 0;
        
        return [record];
    }
}

export default new RainbowStacksBonusRecordBuilder();

export interface BonusResponseSchema {
    RESULTS: Results;
    USER: User;
    time: number;
}

interface Results {
    additionalData: any;
    eval: Eval;
    game: string;
    next_game: string;
    next_game_state: NextGameState;
    games_pending: boolean;
    round_id: number;
    total_bet_cash: number;
    total_win_cash: number;
    state: BonusState;
    persisted_progress: Persisted_Progress;
    updated_free_spin_campaign_details: FreespinUpdate;
}

interface BonusState {
    retriggers: number;
    remain: number;
    jackpotSymbol: string;
    picks: number[];
    is_complete: boolean;
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/integration/revolver/bonus-record-builder.ts